import { Injectable } from '@angular/core';
import { TranslateCompiler } from '@ngx-translate/core';
import { environment } from '../environments/environment';

@Injectable()
export class EnvironmentTranslateCompiler implements TranslateCompiler {

  // 通常の補間（{{value}}）を残すために、ここでは環境変数だけを埋め込む
  compile(value: string, lang: string): string {
    return this.replaceEnvVars(value);
  }

  compileTranslations(translations: any, lang: string): any {
    return this.interpolateEnvironmentRecursive(translations);
  }

  private replaceEnvVars(value: string): string {
    if (typeof value !== 'string') return value;

    // 環境変数だけを埋め込む。残りの {{key}} は ngx-translate の補間に任せる。
    return value.replace(/\{\{(.*?)\}\}/g, (_, varName) => {
      const key = varName.trim();
      const envValue = (environment as any)[key];
      return envValue !== undefined ? envValue : `{{${key}}}`; // 未定義はそのまま残す
    });
  }

  private interpolateEnvironmentRecursive(obj: any): any {
    if (typeof obj === 'string') {
      return this.replaceEnvVars(obj);
    }

    if (typeof obj === 'object' && obj !== null) {
      const result: any = Array.isArray(obj) ? [] : {};
      for (const key in obj) {
        result[key] = this.interpolateEnvironmentRecursive(obj[key]);
      }
      return result;
    }

    return obj;
  }
}
